import { api } from './api'

export type InvoiceType = 'consultation-15' | 'consultation-30' | 'consultation-60' | 'custom'

export type InvoiceStatus = 'draft' | 'sent' | 'paid' | 'failed' | 'cancelled' | 'refunded'

export interface Invoice {
  id: string
  clinic_id: string
  patient_id: string
  type: InvoiceType
  status: InvoiceStatus
  amount: number
  description: string | null
  notes: string | null
  payment_link: string | null
  created_at: string
  updated_at: string
}

export interface CreateInvoicePayload {
  patient_id: string
  type: InvoiceType
  amount?: number
  description?: string
  notes?: string
}

export interface ListInvoicesParams {
  patient_id?: string
  status?: InvoiceStatus
}

export const CONSULTATION_DEFAULTS: Record<Exclude<InvoiceType, 'custom'>, { label: string; amount: number }> = {
  'consultation-15': { label: '15-min Consultation', amount: 75 },
  'consultation-30': { label: '30-min Consultation', amount: 125 },
  'consultation-60': { label: '60-min Consultation', amount: 200 },
}

export const invoiceService = {
  createInvoice: (clinicId: string, payload: CreateInvoicePayload): Promise<Invoice> =>
    api.post(`/clinic/${clinicId}/invoices`, payload),

  listInvoices: (clinicId: string, params?: ListInvoicesParams): Promise<Invoice[]> =>
    api.get(`/clinic/${clinicId}/invoices`, { params }),

  getInvoice: (clinicId: string, invoiceId: string): Promise<Invoice> =>
    api.get(`/clinic/${clinicId}/invoices/${invoiceId}`),

  sendInvoice: (clinicId: string, invoiceId: string): Promise<Invoice> =>
    api.post(`/clinic/${clinicId}/invoices/${invoiceId}/send`),

  cancelInvoice: (clinicId: string, invoiceId: string): Promise<Invoice> =>
    api.post(`/clinic/${clinicId}/invoices/${invoiceId}/cancel`),
}
